<div class="row page-center">
    <div class="with-shadow col-sm-4">
        <h1>LOGIN</h1>
        <form [formGroup]="formLogin" (ngSubmit)="loginSubmit()">
            <div class="form-group">
                <label for="email">Email:</label>
                <input formControlName="email" id="email" class="form-control">
            </div>
            <div class="form-group">
                <label for="password">Password:</label>
                <input formControlName="password" id="password" class="form-control">
            </div>
            <button [disabled]="formLogin.invalid" class="btn btn-primary mt-1">Login</button>
        </form>
        <div class="routs-wrap space-around">
            <a routerLink="/signup">Signup</a>
            <a routerLink="/user/example">Sign in with an example user</a>
        </div>
    </div>
</div>